/**
 * OeffentlicherRahmen — der Rahmen einer Seite ohne App-Shell: Kopf, Inhalt
 * als `<main>`, darunter der Legal-Footer (Regel #21).
 *
 * EINE Stelle für alle Hüllen, die nicht im `Layout` hängen: die anonyme
 * Fassung von `PublicLayoutRoute`, die Einladungsseite, „Bereich
 * deaktiviert", den Wartungsmodus und die letzte Fehlergrenze. Bis zum
 * 03.10.2026 zeigten die vier letzten keinen Footer — Impressum und
 * Datenschutz waren von dort aus nicht erreichbar.
 *
 * `kopf={false}` für die beiden Notfall-Bildschirme: Die letzte Fehlergrenze
 * darf nicht an derselben Kopfzeile scheitern, die vielleicht gerade
 * geworfen hat, und im Wartungsmodus führen Anmelden/Registrieren nirgends hin.
 */
import PublicHeader from './PublicHeader';
import PublicTabNav from './PublicTabNav';
import PublicFooter from './PublicFooter';

// Die Mitte eines Hinweis-Bildschirms (Bereich aus, Wartung) — einmal, damit
// beide gleich aussehen. Steht hier, weil der Wartungsbildschirm in
// `AppRahmen.jsx` lebt und „Bereich deaktiviert" in `App.jsx`.
export const HINWEIS_MITTE = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  flexDirection: 'column',
  gap: '1rem',
  padding: '2rem',
  textAlign: 'center',
};

export default function OeffentlicherRahmen({ children, kopf = true, reiter = false, inhaltStyle }) {
  return (
    <div style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
      {kopf && <PublicHeader />}
      {reiter && <PublicTabNav />}
      <main style={{ flex: 1, width: '100%', boxSizing: 'border-box', ...inhaltStyle }}>
        {children}
      </main>
      <PublicFooter />
    </div>
  );
}
